export * from './header/header.component';
export * from './footer/footer.component';


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/layout/index.ts